<div class="flex-container contact-row-icons" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
  <fa-icon (click)="editContact()" [icon]="['fas', 'file-signature']" class="edit-icon" size="lg"></fa-icon>
  <fa-icon (click)="openAccess()" [icon]="['fas', 'user-lock']" class="access-icon" size="lg"></fa-icon>
  <fa-icon (click)="printContact()" [icon]="['fas', 'print']" class="print-icon" size="lg"></fa-icon>
  <fa-icon [icon]="contactservice.typeIcon(item.type)" class="type-icon" size="lg"></fa-icon>
</div>
<div class="contact-row-icons-extra" fxLayout="row" fxLayoutGap="5px">
  <div *ngIf="isRx" matTooltip="Créer un rapport">
    <fa-icon [icon]="['fal','file-signature']" (click)="createReport()" class="extra-icon" size="lg"></fa-icon>
  </div>
  <div *ngIf="hasExtraIcons" matTooltip="Ouvrir le rapport">
    <fa-icon *ngIf="reportID" (click)="openReport()" [icon]="['fal','file-invoice']" class="extra-icon" size="lg"></fa-icon>
  </div>
</div>
